import type { ApiDocumentRequestStatus, ApiFinancialEventType } from '@/fetcher'

const rublesFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

const wholeRublesFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 0,
})

const usdtFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
})

const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

const dateTimeFormatter = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export const formatRub = (value: string | number) =>
  rublesFormatter.format(Number(String(value).replace(',', '.')))

export const formatWholeRub = (value: string | number) =>
  wholeRublesFormatter.format(
    Math.round(Number(String(value).replace(',', '.'))),
  )

export const formatUsdt = (value: string | number | null | undefined) => {
  if (value === null || value === undefined) return '—'
  const num = Number(String(value).replace(',', '.'))
  if (!Number.isFinite(num)) return '—'
  return usdtFormatter.format(num)
}

export const formatDate = (value: string | null) => {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '—' : dateFormatter.format(date)
}

export const formatDateTime = (value: string | null | undefined) => {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '—' : dateTimeFormatter.format(date)
}

export const DOCUMENT_REQUEST_STATUS_LABELS: Record<
  ApiDocumentRequestStatus,
  string
> = {
  created: 'создано',
  client_paid: 'оплачено',
  bank_received: 'зачислено',
  cancelled: 'отменено',
}

export const FINANCIAL_EVENT_TYPE_LABELS: Record<
  ApiFinancialEventType,
  string
> = {
  client_payment_confirmed: 'Подтверждение оплаты',
  client_usdt_obligation_created: 'Обязательство USDT',
  bank_payment_received: 'Зачисление банком',
  usdt_transfer_sent: 'Перевод USDT',
  manual_adjustment: 'Корректировка',
  referral_obligation_created: 'Реферальное начисление',
  referral_payout_sent: 'Выплата рефералу',
}

export const buildUserLink = (telegramUserId: number | null | undefined) =>
  telegramUserId ? `tg://user?id=${telegramUserId}` : null
